/**
 * Throws unconditionally. Use in the `default` branch of a switch over an enum
 * or discriminated union: the `never` parameter triggers a compile error when a
 * new variant is added but not handled.
 */
export function assertNever(message, _value) {
    throw new Error(message);
}
/**
 * Narrows `value` to a member of `enumObject`. Only string enums are supported:
 * numeric enums compile to a reverse mapping (`{ Red: 0 }` becomes
 * `{ '0': 'Red', Red: 0 }`), so their key names leak into the value set and
 * cannot be told apart from members by value alone. Passing a numeric enum
 * throws — the repo does not allow numeric enums.
 */
export function isEnumMember(enumObject, value) {
    const memberValues = Object.values(enumObject);
    if (memberValues.some((memberValue) => typeof memberValue === 'number')) {
        throw new Error('isEnumMember does not support numeric enums; use a string enum.');
    }
    return memberValues.includes(value);
}
//# sourceMappingURL=types.js.map